/* eslint-disable import/no-extraneous-dependencies */
import { Redirect } from 'react-router-dom';

export const withPrivateRoute =
  (isAuthenticated: Boolean, component: () => JSX.Element): (() => () => JSX.Element) =>
  () =>
    !isAuthenticated ? () => <Redirect to='/login' /> : component;
